import { Link } from 'react-router-dom';
import { SearchableModule } from '@sib/api';
import type { GlobalSearchItemDto } from '@sib/api';
import { cn } from '@sib/ui';
import { GlobalSearchItemContent } from './GlobalSearchItemContent';
import { getGlobalSearchItemPath } from '../GlobalSearch.utils';

interface GlobalSearchResultItemProps {
  item: GlobalSearchItemDto;
  searchTerm: string;
  onSelect?: (item: GlobalSearchItemDto) => void;
  className?: string;
}

export const GlobalSearchResultItem = ({
  item,
  searchTerm,
  onSelect,
  className,
}: GlobalSearchResultItemProps) => {
  const path = getGlobalSearchItemPath(item);
  const resolvedClassName = cn(
    className,
    'hover:bg-muted flex w-full cursor-pointer px-4 py-1 text-left transition-colors'
  );
  const canOpenTaskDetails = !path && item.module === SearchableModule.Tasks;

  if (path)
    return (
      <Link
        to={path}
        onClick={() => onSelect?.(item)}
        className={resolvedClassName}
      >
        <GlobalSearchItemContent item={item} searchTerm={searchTerm} />
      </Link>
    );

  if (canOpenTaskDetails)
    return (
      <button
        type="button"
        className={resolvedClassName}
        onClick={() => onSelect?.(item)}
      >
        <GlobalSearchItemContent item={item} searchTerm={searchTerm} />
      </button>
    );

  return (
    <div className="px-4 py-1">
      <GlobalSearchItemContent item={item} searchTerm={searchTerm} />
    </div>
  );
};
